const AUTH_LIFECYCLE_BYPASS_PATTERNS = ['/book/:linkCode', '/view/booking/:locator'] as const;

function matchesRoutePattern(pathname: string, pattern: string): boolean {
  const pathParts = pathname.split('/');
  const patternParts = pattern.split('/');

  if (pathParts.length !== patternParts.length) {
    return false;
  }

  return patternParts.every((part, index) => part.startsWith(':') || part === pathParts[index]);
}

export function shouldBypassAuthLifecycle(pathname: string): boolean {
  return AUTH_LIFECYCLE_BYPASS_PATTERNS.some(pattern => matchesRoutePattern(pathname, pattern));
}
